import React, { useEffect } from "react";
import { FormControl, Select, Menu, MenuItem, Typography } from "@mui/material";

const Rating = ({ formik }) => {
  return (
    <>
      <FormControl fullWidth>
        <label style={{ margin: "10px 0" }} htmlFor="content-type">
          Viewership Rating
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </label>
        <Select
          name="rating"
          id="rating"
          value={formik.values.rating}
          onChange={formik.handleChange}
        >
          <MenuItem disabled value="">
            <em>Select Rating</em>
          </MenuItem>
          <MenuItem value={"PG"}>PG</MenuItem>
          <MenuItem value={"PG-13"}>PG-13</MenuItem>
          <MenuItem value={"R"}>R</MenuItem>
          <MenuItem value={"G"}>G</MenuItem>
        </Select>
      </FormControl>
      {formik.touched.rating && formik.errors.rating && (
        <Typography sx={{ color: "red" }}>{formik.errors.rating}</Typography>
      )}
    </>
  );
};

export default Rating;
